module.exports = __webpack_public_path__ + "static/img/yi.42f44ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/yi.jpg
// module id = 8iAH
// module chunks = 0